// §5.4 defaults: queries 30 s stale, 5 min gc.
// Uses the in-house minimal query client (src/lib/query/index.ts) that replaces
// @tanstack/react-query to save ~9 kB gzip in the production bundle.
import { QueryClient } from "./index";
import { isTransientQueryError, queryRetryDelayMs } from "./transient";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      networkMode: "offlineFirst",
      retry: (failureCount, error) =>
        isTransientQueryError(error) && failureCount < 3,
      retryDelay: queryRetryDelayMs,
      refetchOnWindowFocus: false,
    },
  },
});
